import { Component, Input } from '@angular/core';
import { BookingSlot } from '../../../../booking/models/booking-slot';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-default-time-slot',
  templateUrl: './default-time-slot.component.html',
  styleUrls: ['./default-time-slot.component.css']
})
export class DefaultTimeSlotComponent {

  @Input()
  bookingSlot: BookingSlot;

  constructor(
  ) { }

  getHourString(floatTime: number): string {
    return environment.globalSettings.getHourString(floatTime);
  }

  getMinutesString(floatTime: number): string {
    return environment.globalSettings.getMinutesString(floatTime);
  }

}
